import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WizardRoutingModule } from './wizard-routing.module';
import { CalendarsModule } from '../calendar/calendar.module'
import { ProfileModule } from '../profile/profile.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MatStepperModule,
  MatInputModule,
  MatButtonModule,
  MatAutocompleteModule,
  MatIconModule, MatCardModule, MatSliderModule, MatSelectModule, MatCheckboxModule, DateAdapter
} from '@angular/material';
import { from } from 'rxjs';
import { RouterModule } from '@angular/router';
import { DemoMaterialModule } from '../demo-material-module';
import { SPSmtpService } from '../profile/profile.service';
import { WizardService } from './wizard.service';
import { TimezoneComponent } from './timezone/timezone.component';
import { SmtpComponent } from './smtp/smtp.component';
import { CalendarService } from '../calendar/calendar.service';
import { GloginsComponent } from './glogins/glogins.component';
import { CalendarComponent } from './calendar/calendar.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SharedModule } from '../shared/shared.module';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { FlatpickrModule } from 'angularx-flatpickr';
import { HttpClientModule } from '@angular/common/http';
import { CalendarModule } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { GoogleApiModule, NgGapiClientConfig, NG_GAPI_CONFIG } from 'ng-gapi';
import { environment } from '../../environments/environment';

let gapiClientConfig: NgGapiClientConfig = {
  client_id: environment.CLIENTID,
  discoveryDocs: ["https://www.googleapis.com/calendar/v3"],
  scope: [
    "https://www.googleapis.com/auth/calendar.readonly",
    "https://www.googleapis.com/auth/calendar"
  ].join(" ")
};


@NgModule({
  imports: [
    CommonModule,
    WizardRoutingModule,
    CommonModule,
    CalendarsModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    DemoMaterialModule,
    MatCardModule,
    MatSliderModule,
    MatCheckboxModule,
    ProfileModule,
    CalendarsModule,




    DemoMaterialModule,
    FlexLayoutModule,
    FormsModule,
    SharedModule,
    NgbModalModule.forRoot(),
    FlatpickrModule.forRoot(),
    HttpClientModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    }),
    GoogleApiModule.forRoot({
      provide: NG_GAPI_CONFIG,
      useValue: gapiClientConfig
      
    }),





  ],
  declarations: [TimezoneComponent, SmtpComponent, GloginsComponent, CalendarComponent],
  exports: [TimezoneComponent, SmtpComponent, GloginsComponent],
  // entryComponents: [GoogleloginComponent],
  providers: [WizardService, SPSmtpService, CalendarService]
})
export class WizardModule { }

